import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'DeleteFacebookComment',
  properties: {
    commentId: prop(String),
  },
});
